import { FC } from "react";
import { get } from "lodash";
import ListItem from "@mui/material/ListItem";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { useDeleteHomeMeta } from "./hooks/useDeleteHomeMeta";
import { useModalHandler } from "hooks/useModalHandler";
import { ConfirmationModal } from "common/ConfirmationModal";
import { Edit } from "common/AllPages/actions/edit";
import { Delete } from "common/AllPages/actions/delete";

export interface HomeMetaCardProps {
  homeMetaData: any;
  homeMeta: [];
  setHomeMeta: any;
}

export const HomeMetaCard: FC<HomeMetaCardProps> = ({
  homeMetaData,
  homeMeta,
  setHomeMeta,
}) => {
  const [isOpen, openModal, closeModal] = useModalHandler();
  const deleteHomeMeta = useDeleteHomeMeta();
  const homeMetaId = get(homeMetaData, "id", "");

  return (
    <ListItem>
      <Box>
        <Typography variant="body2" color="text.primary">
          <b>Page meta tags</b>
        </Typography>
      </Box>
      <Box sx={{ ml: "auto" }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Edit pageId={homeMetaId} pathToEdit="meta/home" />
          {/* @ts-ignore */}
          <Delete clickHandler={openModal} />
        </Box>
      </Box>
      {isOpen && (
        <ConfirmationModal
          // @ts-ignore
          isModalOpen={isOpen}
          // @ts-ignore
          closeModal={closeModal}
          confirmHandler={() => {
            deleteHomeMeta(homeMetaId, homeMeta, setHomeMeta);
            // @ts-ignore
            closeModal();
          }}
          message={`Are you sure you want to remove the home page meta tags?`}
        />
      )}
    </ListItem>
  );
};
